import Vue from 'vue'

import Qs from 'qs'

class OptionGroups {
  async suggest() {
    return await Vue.axios
      .get('app/option-groups/suggest')
  }

  async index({params}) {
    return await Vue.axios
      .get('app/option-groups', {
        params,
        paramsSerializer: (params) => {
          return Qs.stringify(params)
        }
      })
  }

  async create({data}) {
    return await Vue.axios
      .post('app/option-groups', data)
  }

  async read({id}) {
    return await Vue.axios
      .get('app/option-groups/' + id)
  }

  async update({id, data}) {
    return await Vue.axios
      .put('app/option-groups/' + id, data)
  }

  async delete({id}) {
    return await Vue.axios
      .delete('app/option-groups/' + id)
  }
}

const optionGroups = new OptionGroups()

export default optionGroups
